export const defaultConsent = `
<div>
  Wenn Sie auf die externe Seite wechseln, kann es sein, dass Ihre personenbezogene Daten gesammelt und für Werbezwecke oder Profilbildung genutzt werden.
</div>
`;
